import gsap from "gsap/all"
import { ScrollTrigger } from "gsap/ScrollTrigger"

export default function ComponentInfographie() {
    let component = document.querySelectorAll('.c-infographie')
    if (component.length > 0) {
        component.forEach(el => new infographie(el))

    }
}

class infographie {
    constructor(el) {
        this.DOM = el
        this.VIDEO = this.DOM.querySelector('.c-infographie__video');
        this.animationOnEnterView()
    }
    animationOnEnterView() {
        gsap.registerPlugin(ScrollTrigger)

        ScrollTrigger.create({
            trigger: this.DOM,
            onToggle: ({ isActive }) => {
                isActive ? this.playVideo() : this.restartandStopVideo();
            },
        });
    }

    playVideo() {
        this.VIDEO.play()
    }
    restartandStopVideo() {
        this.VIDEO.currentTime = 0;
        this.VIDEO.pause()
    }
}
